import { global } from '../../../globals/constants';
import './tracking.css'; // 👈 Link to custom styles

const airCargo = `${global.icons2}/air-cargo.png`;

export default function TrackingDetailsSection({ data }) {
  return (
    <>
      <div class='timeline'>
        {data?.shipmentDetails.map((item, index) => (
          <div class='event' key={index}>
            <div class='circle'></div>
            <div class='details'>
              <div class='event-content'>
                <div>
                  <div class='title'>{item.event}</div>
                  <div class='info'>
                    {data?.pieceCount} Piece(s) | {data?.weight}
                  </div>
                </div>
                <div class='date'>{item.date}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
